import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { ContractStepModel } from '../../../../models/contract.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { TFormState } from '../../../../models/forms.model';
import { MatDialog } from '@angular/material/dialog';
import { AppcontractStepPaymentEditComponent } from '../contract-step-payment-edit/contract-step-payment-edit.component';
import { AppContractStepPaymentViewComponent } from '../contract-step-payment-view/contract-step-payment-view.component';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractFormService } from '../../services/contract-form.service';


@Component({
    selector: 'app-contract-step-payment',
    templateUrl: './contract-step-payment.component.html',
    styleUrl: './contract-step-payment.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepPaymentComponent {
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP
    constructor(
      private cds:ChangeDetectorRef,
      private dialog:MatDialog,
      private contractFormService:ContractFormService,
    ) { }
    addPayment() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        let paymentEditRef = this.dialog.open(AppcontractStepPaymentEditComponent,{
          panelClass:'payment-edit-dialog-box',
          width:'412px',
          height:'380px'
        })
        paymentEditRef.componentInstance.contractParties = this.contractData?.contract?.projects!
        paymentEditRef.componentInstance.contractStep = this.contractStep!
      })
    }

    viewPayment() {
      if (this.contractStep?.target_key&&this.contractStep.payment_data) {
        let paymentViweRef = this.dialog.open(AppContractStepPaymentViewComponent,{
          panelClass:'payment-edit-dialog-box',
          width:'468px',
          height:'520px'
        })
        paymentViweRef.componentInstance.paymentGuid = this.contractStep?.target_key 
        paymentViweRef.componentInstance.paymentStep = this.contractStep 
        paymentViweRef.componentInstance.contractParties = this.contractData?.contract?.projects!

      }
    }
}